import React from "react";

// Typographic placeholder wordmark used until the official logo is uploaded in Settings.
export const OnyxWordmark = ({ dark = false, className = "" }) => (
  <div className={`flex flex-col leading-none ${className}`} data-testid="onyx-wordmark">
    <span className={`font-display font-extrabold tracking-[0.18em] text-[15px] ${dark ? "text-white" : "text-onyx-black"}`}>
      ONYX
    </span>
    <span className={`font-display font-medium tracking-[0.42em] text-[8px] mt-1 ${dark ? "text-white/60" : "text-onyx-metal"}`}>
      CONTRACTING
    </span>
  </div>
);

export const OnyxLogo = ({ logo, dark = false, className = "" }) => {
  if (logo) return <img src={logo} alt="ONYX CONTRACTING, LLC" className={className} />;
  return <OnyxWordmark dark={dark} className={className} />;
};

export default OnyxLogo;
